import React from 'react';
import { TrendingUp } from 'lucide-react';
import BrainBoard from '../components/BrainBoard';

// The board itself lives in components/BrainBoard.js, shared with Accounting,
// Procurement and Contact Center. This file is only the words, the people and the
// vocabulary. Owners must match the list in
// netlify/functions/lib/improvements-brain-db.js — keep the two in step.
//
// Matt Sr's spec (2026-08-28) asked for statuses of Open / In Progress / Testing /
// Completed. 'testing' is a genuine fourth state on this board rather than a synonym
// for in-progress: an improvement here sits in a real trial for weeks, and the DS
// row-packing test has been running since 2026-08-18. It is offered through config
// rather than by forking the board, so the other three boards still show the four
// statuses they always had.
//
// Blank is a legitimate owner on this board, unlike the others. Matt Sr sent all five
// items as "Owner: TBD", so an unassigned item has to be visible as unassigned rather
// than quietly attributed to whoever seeded it.
const CONFIG = {
  prefix: 'imp',
  section: 'improvements',
  sectionLabel: 'Improvements',
  title: 'Improvements',
  icon: TrendingUp,
  briefFn: 'improvements-brief',
  statuses: ['not_started', 'in_progress', 'testing', 'blocked', 'done'],
  statusLabels: { not_started: 'Open', in_progress: 'In progress', done: 'Completed' },
  cycle: ['not_started', 'in_progress', 'testing', 'blocked'],
  chatGuidance: 'This is the customer-experience improvement list that comes out of the management meetings. It spans buying, grading, the packing floor, checkout and the website, so an item here often belongs to somebody other than the person asking. Most items have real evidence in CPx already: crab age at ship, the feedback comments by product, the Monday digest, the Product Report. Point people at the measurement before they act on an impression, and never quote a number that has not been checked.',
  owners: ['Matt Sr', 'Matt Jr', 'Carman', 'Greg', 'George', 'Rachael', 'Jessica', 'Claude'],
  counterOwners: ['Matt Sr', 'Carman', 'Greg'],
  ownerRank: ['Matt Sr', 'Matt Jr', 'Carman', 'George', 'Rachael', 'Jessica', 'Greg', 'Claude'],
  blurb: 'The things we are actively trying to get better at for the customer, so nothing raised in a meeting or in passing gets forgotten. Anyone can add an item and log dated progress notes against it. Notes are appended and never overwritten, so the history of an item stays readable.',
  docsEmpty: 'No documents stored yet. Test write-ups, supplier notes, packaging trials and anything worth reading twice get added here so they are findable without hunting through email.',
};

export default function ImprovementsBrain() {
  return <BrainBoard config={CONFIG} />;
}
